var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrills(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "418px",
    height: "251px",
    viewBox: "0 0 418 251",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.542808043 0.577152046 5.93568047 0.577152046 5.93568047 5.97067247 0.542808043 5.97067247"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.542808043 0.577152046 5.93568047 0.577152046 5.93568047 5.97067247 0.542808043 5.97067247"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Option-2:-Prompt-w/-alert",
    transform: "translate(-521.000000, -305.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(520.000000, 305.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.6720877,125.78797 C87.6720877,122.80933 85.2572075,120.394449 82.2785672,120.394449 C79.299927,120.394449 76.8850468,122.80933 76.8850468,125.78797 C76.8850468,128.76661 79.299927,131.18149 82.2785672,131.18149 C85.2572075,131.18149 87.6720877,128.76661 87.6720877,125.78797",
    id: "Fill-1-Copy-2",
    fill: "#528AE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0783733,35.9672429 C39.0783733,32.9886026 36.6634931,30.5737224 33.6848529,30.5737224 C30.7062126,30.5737224 28.2913324,32.9886026 28.2913324,35.9672429 C28.2913324,38.9458831 30.7062126,41.3607633 33.6848529,41.3607633 C36.6634931,41.3607633 39.0783733,38.9458831 39.0783733,35.9672429",
    id: "Fill-1-Copy-3",
    fill: "#528AE8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-2",
    transform: "translate(78.671224, 21.755522)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93632847,3.27283226 C5.93632847,1.78459214 4.72888838,0.577152046 3.24064826,0.577152046 C1.75240814,0.577152046 0.542808043,1.78459214 0.542808043,3.27283226 C0.542808043,4.76107238 1.75240814,5.97067247 3.24064826,5.97067247 C4.72888838,5.97067247 5.93632847,4.76107238 5.93632847,3.27283226",
    id: "Fill-3",
    fill: "#30AADE",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-3",
    transform: "translate(0.721090, 212.004511)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93632847,3.27283226 C5.93632847,1.78459214 4.72888838,0.577152046 3.24064826,0.577152046 C1.75240814,0.577152046 0.542808043,1.78459214 0.542808043,3.27283226 C0.542808043,4.76107238 1.75240814,5.97067247 3.24064826,5.97067247 C4.72888838,5.97067247 5.93632847,4.76107238 5.93632847,3.27283226",
    id: "Fill-3",
    fill: "#30AADE",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M172.943083,44.3596443 C172.943083,42.1262041 171.130843,40.316124 168.897403,40.316124 C166.663963,40.316124 164.853883,42.1262041 164.853883,44.3596443 C164.853883,46.5930845 166.663963,48.4053246 168.897403,48.4053246 C171.130843,48.4053246 172.943083,46.5930845 172.943083,44.3596443",
    id: "Fill-6-Copy-2",
    fill: "#30AADE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.198492,92.8243055 C292.198492,90.5908653 290.386252,88.7807852 288.152812,88.7807852 C285.919372,88.7807852 284.109292,90.5908653 284.109292,92.8243055 C284.109292,95.0577457 285.919372,96.8699858 288.152812,96.8699858 C290.386252,96.8699858 292.198492,95.0577457 292.198492,92.8243055",
    id: "Fill-6-Copy-3",
    fill: "#30AADE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6838118,147.980237 C20.6838118,145.746797 18.8737317,143.934557 16.6402915,143.934557 C14.4068513,143.934557 12.5946112,145.746797 12.5946112,147.980237 C12.5946112,150.213678 14.4068513,152.023758 16.6402915,152.023758 C18.8737317,152.023758 20.6838118,150.213678 20.6838118,147.980237",
    id: "Fill-8-Copy-2",
    fill: "#30AADE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.243093,35.9683229 C296.243093,33.7348827 294.433013,31.9226425 292.199572,31.9226425 C289.966132,31.9226425 288.153892,33.7348827 288.153892,35.9683229 C288.153892,38.201763 289.966132,40.0118432 292.199572,40.0118432 C294.433013,40.0118432 296.243093,38.201763 296.243093,35.9683229",
    id: "Fill-8-Copy-3",
    fill: "#30AADE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.158052,54.3596443 C109.158052,52.8714042 107.950612,51.6639641 106.462372,51.6639641 C104.974132,51.6639641 103.764532,52.8714042 103.764532,54.3596443 C103.764532,55.8478844 104.974132,57.0574845 106.462372,57.0574845 C107.950612,57.0574845 109.158052,55.8478844 109.158052,54.3596443",
    id: "Fill-10-Copy-2",
    fill: "#4AD1CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.892504,209.306671 C412.892504,207.818431 411.685063,206.610991 410.196823,206.610991 C408.708583,206.610991 407.498983,207.818431 407.498983,209.306671 C407.498983,210.794911 408.708583,212.004511 410.196823,212.004511 C411.685063,212.004511 412.892504,210.794911 412.892504,209.306671",
    id: "Fill-10-Copy-3",
    fill: "#4AD1CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.764532,174.8915 C103.764532,173.403259 102.554932,172.193659 101.066691,172.193659 C99.5784513,172.193659 98.3710112,173.403259 98.3710112,174.8915 C98.3710112,176.37974 99.5784513,177.58718 101.066691,177.58718 C102.554932,177.58718 103.764532,176.37974 103.764532,174.8915",
    id: "Fill-12-Copy",
    fill: "#4AD1CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6712244,248.105723 C78.6712244,246.617483 77.4637843,245.410043 75.9733842,245.410043 C74.485144,245.410043 73.2777039,246.617483 73.2777039,248.105723 C73.2777039,249.593963 74.485144,250.803563 75.9733842,250.803563 C77.4637843,250.803563 78.6712244,249.593963 78.6712244,248.105723",
    id: "Fill-14-Copy-3",
    fill: "#528AE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.735929,90.1275453 C372.735929,88.6393052 371.528488,87.4318651 370.038088,87.4318651 C368.549848,87.4318651 367.342408,88.6393052 367.342408,90.1275453 C367.342408,91.6157854 368.549848,92.8253855 370.038088,92.8253855 C371.528488,92.8253855 372.735929,91.6157854 372.735929,90.1275453",
    id: "Fill-14-Copy-4",
    fill: "#528AE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.735929,137.978077 C372.735929,136.489837 371.528488,135.282397 370.038088,135.282397 C368.549848,135.282397 367.342408,136.489837 367.342408,137.978077 C367.342408,139.466318 368.549848,140.675918 370.038088,140.675918 C371.528488,140.675918 372.735929,139.466318 372.735929,137.978077",
    id: "Fill-14-Copy-5",
    fill: "#528AE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.636704,134.592131 C311.636704,132.70861 310.109584,131.18149 308.226064,131.18149 C306.342544,131.18149 304.815424,132.70861 304.815424,134.592131 C304.815424,136.475651 306.342544,138.000611 308.226064,138.000611 C310.109584,138.000611 311.636704,136.475651 311.636704,134.592131",
    id: "Fill-16-Copy-3",
    fill: "#30AADE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.875169,61.8159649 C238.875169,59.9324448 237.348049,58.4053246 235.464529,58.4053246 C233.581009,58.4053246 232.053889,59.9324448 232.053889,61.8159649 C232.053889,63.6994851 233.581009,65.2244452 235.464529,65.2244452 C237.348049,65.2244452 238.875169,63.6994851 238.875169,61.8159649",
    id: "Fill-16-Copy-4",
    fill: "#30AADE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.069867,242.001563 C363.069867,240.118042 361.542747,238.590922 359.659227,238.590922 C357.775707,238.590922 356.248586,240.118042 356.248586,242.001563 C356.248586,243.885083 357.775707,245.410043 359.659227,245.410043 C361.542747,245.410043 363.069867,243.885083 363.069867,242.001563",
    id: "Fill-16-Copy-5",
    fill: "#30AADE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.286024,128.48365 C418.286024,126.99541 417.076424,125.78797 415.588184,125.78797 C414.099944,125.78797 412.892504,126.99541 412.892504,128.48365 C412.892504,129.97405 414.099944,131.18149 415.588184,131.18149 C417.076424,131.18149 418.286024,129.97405 418.286024,128.48365",
    id: "Fill-18-Copy-2",
    fill: "#4AD1CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.474627,2.69568021 C213.474627,1.2074401 212.265027,0 210.776787,0 C209.288547,0 208.081107,1.2074401 208.081107,2.69568021 C208.081107,4.18608033 209.288547,5.39352043 210.776787,5.39352043 C212.265027,5.39352043 213.474627,4.18608033 213.474627,2.69568021",
    id: "Fill-18-Copy-3",
    fill: "#4AD1CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.641066,193.87952 C348.641066,191.77784 346.936826,190.07576 344.835146,190.07576 C342.737785,190.07576 341.033545,191.77784 341.033545,193.87952 C341.033545,195.9812 342.737785,197.68328 344.835146,197.68328 C346.936826,197.68328 348.641066,195.9812 348.641066,193.87952",
    id: "Fill-20-Copy-3",
    fill: "#FDD972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.248586,43.8156035 C356.248586,41.7139233 354.544346,40.0118432 352.442666,40.0118432 C350.345306,40.0118432 348.641066,41.7139233 348.641066,43.8156035 C348.641066,45.9172836 350.345306,47.6193638 352.442666,47.6193638 C354.544346,47.6193638 356.248586,45.9172836 356.248586,43.8156035",
    id: "Fill-20-Copy-4",
    fill: "#FDD972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2913324,89.0216252 C28.2913324,86.919945 26.5870923,85.2178649 24.4854121,85.2178649 C22.388052,85.2178649 20.6838118,86.919945 20.6838118,89.0216252 C20.6838118,91.1233054 22.388052,92.8253855 24.4854121,92.8253855 C26.5870923,92.8253855 28.2913324,91.1233054 28.2913324,89.0216252",
    id: "Fill-20-Copy-5",
    fill: "#FDD972"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrills);
export default __webpack_public_path__ + "static/media/frills.1e0f23507e1a8e1a46b3a94f959097c1.svg";
export { ForwardRef as ReactComponent };